import { parse, isValid, format, compareAsc } from "date-fns";
import type { ParamsBuilder, RowState } from "../types";
import { helper } from "./helper";

const parseMonth = (value?: string) => {
  if (!value) return undefined;
  const parsed = parse(value, "yyyy-MM", new Date());
  if (!isValid(parsed)) return undefined;
  parsed.setDate(1);
  parsed.setHours(0, 0, 0, 0);
  return parsed;
};

const toMonthToken = (date: Date) => format(date, "yyyy-MM");

export class DateMonthBuilder implements ParamsBuilder {
  build(row: RowState): object {
    const month = parseMonth(row.value);
    const sharedOptions = { multiTableSearch: row.multiTableSearch } as const;

    switch (row.operator) {
      case "on": {
        if (!month) return {};
        return {
          [row.fieldName]: helper({ equals: toMonthToken(month) }, sharedOptions)
        };
      }
      case "after": {
        if (!month) return {};
        return {
          [row.fieldName]: helper({ gt: toMonthToken(month) }, sharedOptions)
        };
      }
      case "before": {
        if (!month) return {};
        return {
          [row.fieldName]: helper({ lt: toMonthToken(month) }, sharedOptions)
        };
      }
      case "between": {
        const endMonth = parseMonth(row.value2);
        if (!month || !endMonth) return {};
        const [min, max] = compareAsc(month, endMonth) <= 0 ? [month, endMonth] : [endMonth, month];
        return {
          [row.fieldName]: helper({ gte: toMonthToken(min), lte: toMonthToken(max) }, sharedOptions)
        };
      }
      default:
        return {};
    }
  }
}
